const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.farmako.app';

/** When set (e.g. `https://api.internal.farmako.app`), B2B wallet ops call this host (VPN / Cloudflare Access). */
export const INTERNAL_API_BASE_URL = (process.env.REACT_APP_INTERNAL_API_BASE_URL || '').trim();

export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  INTERNAL_API_BASE_URL,
  ENDPOINTS: {
    USERS_SEND_OTP: '/api/users/sendOTP',
    USERS_LOGIN_OTP: '/api/users/loginOTP',
    USERS_REFRESH: '/api/users/refresh',
    USERS_LOGOUT: '/api/users/logout',
    WALLET_BASE: '/app/public/wallet',
    WALLET_DETAIL: (walletId) => `/app/public/wallet/${encodeURIComponent(walletId)}`,
    WALLET_STATEMENT: (walletId) =>
      `/app/public/wallet/${encodeURIComponent(walletId)}/statement`,
    WALLET_INVOICE: (walletId, referenceId) =>
      `/app/public/wallet/${encodeURIComponent(walletId)}/invoice/${encodeURIComponent(referenceId)}`,
    WALLET_CASH_TRANSFER: (walletId) =>
      `/app/public/wallet/${encodeURIComponent(walletId)}/transfers`,
    WALLET_CREDIT_ISSUE_REQUESTS: (walletId) =>
      `/app/public/wallet/${encodeURIComponent(walletId)}/credit-issue-requests`,
    INTERNAL_WALLET_PING: '/app/public/internal/wallet/ping',
    INTERNAL_WALLET_REPAYMENT: (walletId) =>
      `/app/public/internal/wallet/${encodeURIComponent(walletId)}/repayment`,
    INTERNAL_WALLET_CREDIT_LINE: (walletId) =>
      `/app/public/internal/wallet/${encodeURIComponent(walletId)}/credit-line`,
    INTERNAL_WALLET_NON_USER_WALLETS: '/app/public/internal/wallet/non-user-wallets',
    INTERNAL_WALLET_CREDIT_ISSUE_REQUEST_APPROVE: (walletId, requestId) =>
      `/app/public/internal/wallet/${encodeURIComponent(walletId)}/credit-issue-requests/${encodeURIComponent(requestId)}/approve`,
    INTERNAL_WALLET_CREDIT_ISSUE_REQUEST_REJECT: (walletId, requestId) =>
      `/app/public/internal/wallet/${encodeURIComponent(walletId)}/credit-issue-requests/${encodeURIComponent(requestId)}/reject`,
  },
};

export const getAuthHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
});
